import type { FC } from 'react';
import { Calendar, Cost, Duration, Location, Offline, OnlineIcon, Time } from '@shared/assets';
import { getCosts } from '@shared/helpers';
import { useUser } from '@shared/hooks';
import { getDuration, getShort, getTime } from 'library/helpers/events/dateSets';
import { getEventPlace } from 'library/helpers/events/normalizeEventValue';
import type { Event } from 'library/models/events';
import { Description } from './frames';

interface Props {
  event: Event;
  size: 'large' | 'small';
  type: 'type' | 'date' | 'time' | 'cost' | 'place' | 'duration' | 'typeMeeting' | 'phone';
}

const EventDescription: FC<Props> = ({ event, size, type }) => {
  const { costs, cost } = event;
  const { user } = useUser();
  const isAuthor = event.author.id === user?.id;

  const hasCustomGroup = user?.custom_groups && user?.custom_groups?.length > 0;

  const sortedGroupCost = [...costs]
    ?.filter((group) => user?.custom_groups?.find((custGroup) => group.group.id === custGroup.id))
    .sort((a, b) => a.cost - b.cost);

  const costValues =
    isAuthor && costs.length > 0
      ? `${getCosts(event.cost, event.costs).min / 100} - ${getCosts(event.cost, event.costs).max / 100}`
      : hasCustomGroup && sortedGroupCost.length
        ? sortedGroupCost[0].cost / 100
        : cost / 100;

  return (
    <>
      {type === 'type' && (
        <Description
          title={event?.event_type ?? ''}
          size={size}
          svg={event?.mode === 'O' ? <Offline /> : <OnlineIcon />}
        />
      )}

      {type === 'typeMeeting' && (
        <Description
          title={event?.mode === 'O' ? event?.address?.city : 'Онлайн'}
          // title={event?.mode === 'O' ? 'event.address.city' : 'Онлайн'}
          size={size}
          svg={event?.mode === 'O' ? <Location /> : <OnlineIcon />}
        />
      )}

      {type === 'place' && (
        <Description
          title={event?.mode === 'O' ? getEventPlace(event.address) : 'Онлайн'}
          size={size}
          svg={event?.mode === 'O' ? <Location /> : <OnlineIcon />}
        />
      )}

      {type === 'duration' && !!event?.timetable?.length && (
        <Description title={getDuration(event.timetable)} size={size} svg={<Duration />} />
      )}

      {type === 'cost' && (
        <Description
          title={costValues === 0 ? 'Бесплатно' : `${costValues} RUB`}
          size={size}
          svg={<Cost />}
        />
      )}
      {type === 'date' && (
        <Description title={getShort(event?.time_from)} size={size} svg={<Calendar />} />
      )}
      {type === 'time' && (
        <Description title={getTime(event?.time_from)} size={size} svg={<Time />} />
      )}
    </>
  );
};

export default EventDescription;
